import { useMemo } from "react";
import { estadoMap, estadoTelefonicaMap, estadoDocumentalMap } from "./ListadoSolicitud.constants";

// Hook que agrupa todas las funciones de chequeo de permisos de
// ListadoSolicitud.js. Cada función conserva exactamente su lógica original
// (mismo nombre de permiso buscado, mismo valor de retorno); lo único que
// cambia es que ahora reciben `permisos` por parámetro del hook en vez de
// cerrar directamente sobre el estado del componente.
//
// Todas dependen únicamente de `permisos`, así que se memorizan juntas en un
// solo useMemo: mientras `permisos` no cambie de referencia (no se vuelva a
// llamar setPermisos), las funciones devueltas mantienen la misma identidad
// entre renders — necesario para que React.memo en los componentes que las
// reciben (ej. SolicitudTableRow) realmente evite re-renders innecesarios.
export default function usePermisosListado(permisos) {
  return useMemo(() => {
    const tienePermiso = (nombrePermiso) => {
    const permiso = permisos.find((p) => p.Permisos === nombrePermiso);
    return permiso && permiso.Activo;
  };

  const noTienePermiso = (nombrePermiso) => {
    const permiso = permisos.find((p) => p.Permisos === nombrePermiso);
    return !permiso || !permiso.Activo;
  };

  const permisoAprobarResultado = (data) => noTienePermiso("EDITAR RESULTADO");

  const permisoAprobarEstado = (data) => noTienePermiso("EDITAR ESTADO");

  const tienePermisoEditarAnalista = () => tienePermiso("EDITAR ANALISTA");

  const permisoEditarOperador = () => tienePermiso("EDITAR OPERADORA");

  const permitirEquifax = () => tienePermiso("CONSULTA EQUIFAX");

  const imprimirInforme = () => tienePermiso("IMPRIMIR INFORME SOLICITUDES");

  const crearYupana = () => tienePermiso("CREA SOLICITUD YUPANA");

  const permisoReasignarVerificador = () => tienePermiso("REASIGNAR VERIFICADOR");

  const permisoEditarVerificacionTerreno = () => tienePermiso("EDITAR VERIFICACION TERRENA");

  const permisoReasignarDomicilio = () => tienePermiso("DESABILITAR DOMICILIO");

  const permisoAgregarObservacionCredito = () => tienePermiso("AGREGAR OBSERVACION CREDITO");

  const permisoReasignarLaboral = () => tienePermiso("DESABILITAR LABORAL");

  const permisoCambiarBodega = () => tienePermiso("CAMBIAR BODEGA");

  const puedeCrearSolicitud = () => tienePermiso("INGRESAR SOLICITUDES NUEVAS");

  const puedeCrearSolicitudNueva = () => tienePermiso("INGRESAR SOLICITUDES NUEVAS V2");

  const aporbarsinregistrocivil = () => tienePermiso("VALIDAR FOTO RC");

  const puedeDescargarDocumentosBS = () => tienePermiso("DESCARGAR DOCUMENTOS BANCO SOLIDARIO");
  const estadoDeshabilitadoporPermisos = (data) => {
    // Obtener el estado correspondiente al ID
    const estado = estadoMap[data.idEstadoVerificacionSolicitud];

    if (!estado) return true; // Si el estado no está mapeado, deshabilitar por seguridad

    // Buscar el permiso correspondiente en la lista de permisos
    return noTienePermiso(`EDITAR SOLICITUD ${estado}`);
  };

  const estadoDeshabilitadotelefonica = (data) => {
    // Obtener el estado correspondiente al ID
    const estado = estadoTelefonicaMap[data.idEstadoVerificacionTelefonica];

    if (!estado) return true; // Si el estado no está mapeado, deshabilitar por seguridad
    // Buscar el permiso correspondiente en la lista de permisos
    return noTienePermiso(`EDITAR TELEFONICA ${estado}`);
  };

  const estadoDeshabilitadoDocumental = (data) => {
    // Obtener el estado correspondiente al ID
    const estado = estadoDocumentalMap[data.idEstadoVerificacionDocumental];

    if (!estado) return true; // Si el estado no está mapeado, deshabilitar por seguridad
    // Buscar el permiso correspondiente en la lista de permisos
    return noTienePermiso(`EDITAR DOCUMENTAL ${estado}`);
  };

    return {
      permisoAprobarResultado,
      permisoAprobarEstado,
      tienePermisoEditarAnalista,
      permisoEditarOperador,
      permitirEquifax,
      imprimirInforme,
      crearYupana,
      permisoReasignarVerificador,
      permisoEditarVerificacionTerreno,
      permisoReasignarDomicilio,
      permisoAgregarObservacionCredito,
      permisoReasignarLaboral,
      permisoCambiarBodega,
      puedeCrearSolicitud,
      puedeCrearSolicitudNueva,
      estadoDeshabilitadoporPermisos,
      estadoDeshabilitadotelefonica,
      estadoDeshabilitadoDocumental,
      aporbarsinregistrocivil,
      puedeDescargarDocumentosBS,
    };
  }, [permisos]);
}
